// ErrorPopup is a simple popup that displays an error message.

import Modal from 'app/src/modals/Modal';
import * as React from 'react';

interface Props {
	errorMessage?: string;
	errorDetails?: string;
	onClose: () => void;
}

export default function ErrorPopup({
	errorMessage,
	errorDetails,
	onClose,
}: Props): React.ReactElement {
	return (
		<Modal className="ErrorPopup">
			<div className="ErrorPopup-errorMessageContainer">
				<p className="ErrorPopup-errorMessage">{errorMessage || ''}</p>
				<p className="ErrorPopup-errorDetails">{errorDetails || ''}</p>
			</div>
			<div className="ErrorPopup-controls">
				<button
					className="ErrorPopup-control ErrorPopup-control--ok"
					onClick={(): void => onClose()}
				>
					OK
				</button>
			</div>
		</Modal>
	);
}
